import { render, staticRenderFns } from "./ApplyForWish.vue?vue&type=template&id=5fab9f00&scoped=true&"
import script from "./ApplyForWish.vue?vue&type=script&lang=js&"
export * from "./ApplyForWish.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForWish.vue?vue&type=style&index=0&id=5fab9f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab9f00",
  null
  
)

export default component.exports